var map = {
	"./tombola-online-de.md": 9388,
	"./tombola-online-en.md": 1824,
	"./tombola-online-es.md": 1683,
	"./tombola-online-fr.md": 9382,
	"./tombola-online-it.md": 1835,
	"./tombola-online-pt.md": 562,
	"./tombola-online-ro.md": 2072,
	"./tombola-online-ru.md": 3817,
	"./tombola-online-tr.md": 6903
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2066;